import script from "./CrossMintSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./CrossMintSuccess.vue?vue&type=script&setup=true&lang=js"

import "./CrossMintSuccess.vue?vue&type=style&index=0&id=a831aea0&lang=scss"

const __exports__ = script;

export default __exports__